import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function LegalPage({ title, updated, sections, testid }) {
    return (
        <div className="min-h-screen bg-paper font-body text-ink" data-testid={testid}>
            <Navbar />
            <div className="mx-auto max-w-3xl px-6 pb-24 pt-32">
                <Link
                    to="/"
                    data-testid="legal-back-link"
                    className="inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.18em] text-mute transition-colors hover:text-ink"
                >
                    <ArrowLeft size={13} /> Back to home
                </Link>
                <motion.h1
                    initial={{ opacity: 0, y: 24 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
                    className="mt-8 font-display text-4xl font-bold tracking-tight text-ink md:text-5xl"
                >
                    {title}
                </motion.h1>
                <p className="mt-3 font-mono text-[11px] uppercase tracking-[0.18em] text-mute">
                    Effective & last updated · {updated}
                </p>

                <div className="mt-12 space-y-10">
                    {sections.map((s) => (
                        <section key={s.h} data-testid={`legal-section-${s.h.split(".")[0]}`}>
                            <h2 className="font-display text-xl font-bold text-ink">{s.h}</h2>
                            <div className="mt-3 space-y-3 text-sm leading-relaxed text-mute">
                                {s.body.map((b, i) =>
                                    b.list ? (
                                        <ul key={i} className="list-disc space-y-1.5 pl-5">
                                            {b.list.map((li, j) => (
                                                <li key={j}>{li}</li>
                                            ))}
                                        </ul>
                                    ) : b.sh ? (
                                        <h3 key={i} className="pt-2 text-sm font-bold text-ink">
                                            {b.sh}
                                        </h3>
                                    ) : (
                                        b.p && <p key={i}>{b.p}</p>
                                    ),
                                )}
                            </div>
                        </section>
                    ))}
                </div>
            </div>
            <Footer />
        </div>
    );
}
